import { Map, List, fromJS } from 'immutable'

/**
 * Active project
 */

export function activeProject(state = false, action) {
  let { type: t } = action
  let current = state || Map()
  let interviews = current.get('interviews', List())
  let people = current.get('people', List())
  let tasks = current.get('tasks', List())

  /**
   * Project default actions
   */
  if (t === 'PROJECT_FETCH_ITEM_RESET') return Map()

  if (t === 'PROJECT_FETCH_ITEM_SUCCESS') return fromJS(action.item)

  if (t === 'PROJECT_UPDATE_SUCCESS') return current.merge(fromJS(action.item))

  /**
   * Interview actions
   */

  if (t === 'PROJECT_CREATE_INTERVIEW_SUCCESS') return current.set('interviews', interviews.push(fromJS(action.item)))

  if (t === 'PROJECT_UPDATE_INTERVIEW_SUCCESS')
    return current.set(
      'interviews',
      interviews.map(i => {
        if (i.get('id') !== action.item.id) return i

        return i.merge(fromJS(action.item))
      })
    )

  if (t === 'PROJECT_DELETE_INTERVIEW_SUCCESS')
    return current.set(
      'interviews',
      interviews.filter(i => i.get('id') !== action.itemId)
    )

  /**
   * Task actions
   */

  if (t === 'PROJECT_CREATE_TASK_SUCCESS')
    return current.set(
      'interviews',
      interviews.map(i =>
        i.get('id') === action.interviewId ? i.set('tasks', i.get('tasks', List()).push(fromJS(action.item))) : i
      )
    )

  if (t === 'PROJECT_UPDATE_TASK_SUCCESS')
    return current.set(
      'interviews',
      interviews.map(i =>
        i.get('id') === action.interviewId
          ? i.set(
              'tasks',
              i.get('tasks', List()).map(t => (t.get('id') === action.item.id ? fromJS(action.item) : t))
            )
          : i
      )
    )

  if (t === 'TASK_CREATE_SUCCESS') {
    let createdTask = action.item || {}

    if (createdTask && createdTask.project_id === current.get('id')) {
      if (createdTask.interview_id) {
        return current.set(
          'interviews',
          interviews.map(i =>
            i.get('id') === createdTask.interview_id
              ? i.set('tasks', i.get('tasks', List()).push(fromJS(createdTask)))
              : i
          )
        )
      } else {
        return current.set('tasks', tasks.push(fromJS(createdTask)))
      }
    }

    return current
  }

  if (t === 'TASK_EDIT_SUCCESS') {
    let updatedTask = action.item || {}

    if (updatedTask && updatedTask.project_id === current.get('id')) {
      if (updatedTask.interview_id) {
        return current.set(
          'interviews',
          interviews.map(i =>
            i.get('id') === updatedTask.interview_id
              ? i.set(
                  'tasks',
                  i.get('tasks', List()).map(t => (t.get('id') === updatedTask.id ? fromJS(updatedTask) : t))
                )
              : i
          )
        )
      } else {
        return current.set(
          'tasks',
          tasks.map(t => (t.get('id') === updatedTask.id ? fromJS(updatedTask) : t))
        )
      }
    }

    return current
  }

  if (t === 'TASK_BATCH_UPDATE') {
    let updatedTasks = action.items || []
    return current
      .set(
        'interviews',
        interviews.map(i => {
          return i.set(
            'tasks',
            i.get('tasks', List()).map(task => {
              let updatedTask = updatedTasks.find(({ id }) => id === task.get('id'))
              return updatedTask ? task.merge(fromJS(updatedTask)) : task
            })
          )
        })
      )
      .set(
        'tasks',
        current.get('tasks', List()).map(task => {
          let updatedTask = updatedTasks.find(({ id }) => id === task.get('id'))
          return updatedTask ? task.merge(fromJS(updatedTask)) : task
        })
      )
  }

  /**
   * People actions
   */

  if (t === 'PEOPLE_BATCH_CREATE_SUCCESS') {
    if (current.get('id') !== action.project_id) return current

    let createdPeople = fromJS(action.people)
    if (!List.isList(createdPeople)) return current

    return current.set('people', people.concat(createdPeople))
  }

  if (t === 'PEOPLE_EDIT_SUCCESS') {
    if (current.get('id') !== action.project_id) return current

    let item = action.item || {}

    current = current.set(
      'people',
      people.map(person => {
        if (person.get('id') === item.id) return fromJS(item)

        return person
      })
    )

    current = current.set(
      'interviews',
      interviews.map(interview => {
        let id = interview.get('id')

        if (action.update_new_interview && id === action.update_new_interview.id)
          return interview.merge(fromJS(action.update_new_interview))

        if (action.update_old_interview && id === action.update_old_interview.id)
          return interview.merge(fromJS(action.update_old_interview))

        return interview
      })
    )

    return current
  }

  /**
   * Manage person
   */

  if (t === 'PROJECT_MANAGE_PERSON_SUCCESS') {
    if (current.get('id') !== action.projectId) return current

    let item = action.item || {}

    /* Update person info */
    current = current.set(
      'people',
      people.map(person => {
        if (person.get('id') === item.id) return fromJS(item)

        return person
      })
    )

    let { update_new_interview = {}, update_old_interview = {} } = action

    /* Update interview if changed */
    current = current.set(
      'interviews',
      current.get('interviews', List()).map(interview => {
        let id = interview.get('id')

        if (id === update_new_interview.id) return interview.merge(fromJS(update_new_interview))

        if (id === update_old_interview.id) return interview.merge(fromJS(update_old_interview))

        return interview
      })
    )

    /* Update interview task */
    if (action.task) {
      current = current.set(
        'interviews',
        current.get('interviews', List()).map(i => {
          if (i.get('id') !== action.task.interview_id) return i

          let tasks = i.get('tasks', List())

          let task = tasks.find(t => t.get('id') === action.task.id)

          if (task) {
            tasks = tasks.map(t => (t.get('id') === action.task.id ? fromJS(action.task) : t))
          } else {
            tasks = tasks.push(fromJS(action.task))
          }
          return i.set('tasks', tasks)
        })
      )
    }

    return current
  }

  /**
   * Remove task on delete success
   */
  if (t === 'TASK_DELETE_SUCCESS') {
    let { item = {} } = action
    if (item.project_id === current.get('id')) {
      return current.set(
        'interviews',
        current.get('interviews', List()).map(i => {
          if (i.get('id') !== item.interview_id) return i

          return i.set(
            'tasks',
            i.get('tasks', List()).filter(t => t.get('id') !== item.id)
          )
        })
      )
    }
  }

  /**
   * Contact actions
   */

  if (t === 'CONTACT_ATTACH_SUCCESS' || t === 'CONTACT_CREATE_SUCCESS') {
    let contactProjects = action.item.projects || []
    if (!contactProjects.find(p => p.id === current.get('id'))) return current

    return current.set('contacts', current.get('contacts', List()).push(fromJS(action.item)))
  }

  if (t === 'CONTACT_DEATTACH_SUCCESS') {
    let target = action.target || {}
    if (target.project_id !== current.get('id')) return current

    return current.set(
      'contacts',
      current.get('contacts', List()).filter(c => c.get('id') !== action.item.id)
    )
  }

  /**
   * Approval
   */

  if (t === 'PROJECT_CREATE_APPROVAL_SUCCESS')
    return current.set(
      'interviews',
      current.get('interviews', List()).map(i => {
        if (i.get('id') !== action.interviewId) return i

        return i.set('approvals', i.get('approvals', List()).push(fromJS(action.item)))
      })
    )

  if (
    t === 'PROJECT_UPDATE_APPROVAL_SUCCESS' ||
    t === 'PROJECT_RUN_APPROVAL_ACTION_SUCCESS' ||
    t == 'PROJECT_ADMIN_APPROVAL_SUCCESS'
  )
    return current.set(
      'interviews',
      current.get('interviews', List()).map(i => {
        if (i.get('id') !== action.interviewId) return i

        return i.set(
          'approvals',
          i.get('approvals', List()).map(a => (a.get('id') === action.approvalId ? fromJS(action.item) : a))
        )
      })
    )

  if (t === 'PROJECT_DELETE_APPROVAL_SUCCESS')
    return current.set(
      'interviews',
      current.get('interviews', List()).map(i => {
        if (i.get('id') !== action.interviewId) return i

        return i.set(
          'approvals',
          i.get('approvals', List()).filter(a => a.get('id') !== action.approvalId)
        )
      })
    )

  /**
   * Interview status change
   */

  if (t === 'INTERVIEW_STATUS_SUCCESS' && action.item.project_id === current.get('id'))
    return current.set(
      'interviews',
      current.get('interviews', List()).map(i => {
        if (i.get('id') === action.interview_id) return i.set('status', action.item.status)

        return i
      })
    )

  return state
}

export function activeProjectLoading(state = true, action) {
  if (action.type === 'PROJECT_FETCH_ITEM_LOADING') return action.isLoading

  if (action.type === 'PROJECT_FETCH_ITEM_SUCCESS') return false

  return state
}

export function activeProjectError(state = false, action) {
  if (action.type === 'PROJECT_FETCH_ITEM_ERROR') return action.message

  return state
}

/**
 * Project task managemenet
 */

export function projectTaskAdding(state = false, action) {
  if (action.type === 'PROJECT_ADD_TASK') return action.add || false
  if (action.type === 'TASK_CREATE_SUCCESS') return false

  return state
}

export function projectTaskEditing(state = false, action) {
  if (action.type === 'PROJECT_EDIT_TASK') return action.id || false
  if (action.type === 'TASK_EDIT_SUCCESS') return false
  if (action.type === 'TASK_DELETE_SUCCESS') return false

  return state
}

/**
 * Create
 */

export function createProjectLoading(state = false, action) {
  if (action.type === 'PROJECT_CREATE_LOADING') return action.loading

  if (action.type === 'PROJECT_CREATE_SUCCESS' || action.type === 'PROJECT_CREATE_FAIL') return false

  return state
}

export function createProjectFail(state = false, action) {
  if (action.type === 'PROJECT_CREATE_FAIL') return action.message

  return state
}

export function projectCreating(state = false, action) {
  if (action.type === 'PROJECT_CREATE') return action.creating

  if (action.type === 'PROJECT_CREATE_SUCCESS') return false

  return state
}

/**
 * Project update
 */

export function updateProjectLoading(state = false, action) {
  if (action.type === 'UPDATE_PROJECT_LOADING') return action.loading

  return state
}

export function updateProjectFail(state = false, action) {
  if (action.type === 'UPDATE_PROJECT_ERROR') return action.message

  return state
}

/**
 * Order editor
 */

export function orderEditorSaving(state = false, action) {
  if (action.type === 'PROJECT_ORDER_EDITOR_SAVING') return action.saving

  return state
}

/**
 * Create interview
 */

export function projectCreateInterviewLoading(state = false, action) {
  if (action.type === 'PROJECT_CREATE_INTERVIEW_LOADING') return action.loading

  if (action.type === 'PROJECT_CREATE_INTERVIEW_SUCCESS') return false

  return state
}

export function projectCreateInterviewError(state = false, action) {
  if (action.type === 'PROJECT_CREATE_INTERVIEW_ERROR') return action.message

  return state
}

/**
 * Update interview
 */

export function projectUpdateInterviewLoading(state = false, action) {
  if (action.type === 'PROJECT_UPDATE_INTERVIEW_LOADING') return action.loading

  return state
}

export function projectUpdateInterviewError(state = false, action) {
  if (action.type === 'PROJECT_UPDATE_INTERVIEW_ERROR') return action.message

  return state
}

/**
 * Delete interview
 */

export function projectDeleteInterviewLoading(state = false, action) {
  if (action.type === 'PROJECT_DELETE_INTERVIEW_LOADING') return action.loading

  return state
}

export function projectDeleteInterviewError(state = false, action) {
  if (action.type === 'PROJECT_DELETE_INTERVIEW_ERROR') return action.message

  return state
}

/**
 * Project view hide sidebar
 */

export function projectViewSideHidden(state = localStorage.projectViewSideHidden || false, action) {
  if (action.type === 'PROJECT_SIDE_VIEW_HIDDEN') return action.hidden

  if (state === 'false') return false

  return state
}

/* Approval */

export function projectCreateApprovalLoading(state = false, action) {
  if (action.type === 'PROJECT_CREATE_APPROVAL_LOADING') return action.loading

  if (action.type === 'PROJECT_CREATE_APPROVAL_ERROR' || action.type === 'PROJECT_CREATE_APPROVAL_SUCCESS') return false

  return state
}

export function projectCreateApprovalError(state = false, action) {
  if (action.type === 'PROJECT_CREATE_APPROVAL_ERROR') return action.message

  return state
}

export function projectUpdateApprovalLoading(state = false, action) {
  if (action.type === 'PROJECT_UPDATE_APPROVAL_LOADING') return action.loading

  if (action.type === 'PROJECT_UPDATE_APPROVAL_ERROR' || action.type === 'PROJECT_UPDATE_APPROVAL_SUCCESS') return false

  return state
}

export function projectUpdateApprovalError(state = false, action) {
  if (action.type === 'PROJECT_UPDATE_APPROVAL_ERROR') return action.message

  return state
}

export function projectDeleteApprovalLoading(state = false, action) {
  if (action.type === 'PROJECT_DELETE_APPROVAL_LOADING') return action.loading

  if (action.type === 'PROJECT_DELETE_APPROVAL_ERROR' || action.type === 'PROJECT_DELETE_APPROVAL_SUCCESS') return false

  return state
}

export function projectDeleteApprovalError(state = false, action) {
  if (action.type === 'PROJECT_DELETE_APPROVAL_ERROR') return action.message

  return state
}

export function projectRunApprovalActionLoading(state = false, action) {
  if (action.type === 'PROJECT_RUN_APPROVAL_ACTION_LOADING') return action.loading

  if (action.type === 'PROJECT_RUN_APPROVAL_ACTION_ERROR' || action.type === 'PROJECT_RUN_APPROVAL_ACTION_SUCCESS')
    return false

  return state
}

export function projectRunApprovalActionError(state = false, action) {
  if (action.type === 'PROJECT_RUN_APPROVAL_ACTION_ERROR') return action.message

  return state
}

export function projectApprovalActionStatus(state = Map(), action) {
  if (action.type === 'PROJECT_APPROVAL_ACTION_STATUS') {
    if (state.has(action.approvalId)) return state.remove(action.approvalId)

    return state.set(action.approvalId, action.status || 'info')
  }

  return state
}
